<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item label="路由编号">
            <el-input v-model="form.routeId" placeholder="路由编号"></el-input>
          </el-form-item>

          <el-form-item label="渠道">
            <el-input
              v-model="form.channelId"
              placeholder="渠道编号/渠道名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="商户名称">
            <el-select
              v-model="form.appId"
              filterable
              placeholder="--请选择--"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="强制路由">
            <el-select v-model="form.routeStatus" placeholder="请选择">
              <el-option label="--请选择--" value=""></el-option>
              <el-option label="开通" value="01"></el-option>
              <el-option label="关闭" value="00"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="创建日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="addRoute" size="small"
            >添加路由</el-button
          >
        </template>

        <template slot="tableColumn">
          <!-- <el-table-column
            prop="routeId"
            label="路由编号"
            width="160px"
            align="center"
          >
          </el-table-column> -->

          <el-table-column
            prop="agentId"
            label="agentId"
            width="120px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="appId"
            label="AppID"
            width="160px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="merName"
            label="商户名称"
            width="150px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="rate"
            label="代收费率(%)"
            width="120px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="fee"
            label="代付费率(%)"
            width="120px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="routeStatus"
            label="强制路由"
            :formatter="$formatter.formatRouteStatus"
            width="100px"
            align="center"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="channelId"
            label="代收渠道编号"
            width="120px"
            align="center"
          >
          </el-table-column> -->

          <el-table-column
            prop="channelName"
            label="代收渠道名称"
            width="200px"
            align="center"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="withdrawChannelId"
            label="代付渠道编号"
            width="120px"
            align="center"
          >
          </el-table-column> -->

          <el-table-column
            prop="withdrawChannelName"
            label="代付渠道名称"
            width="200px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="createUser"
            label="创建人"
            width="180px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="$formatter.formatDate"
            width="160px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="updateUser"
            label="更新人"
            width="180px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateUser">{{ row.updateUser }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="updateTime"
            label="更新时间"
            width="160px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateTime">
                {{ $formatter.formatDate(null, null, row.updateTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="small"
                @click="updateEdit(scope.row, 1)"
                >查看</el-button
              > -->
              <el-button
                type="primary"
                size="mini"
                plain
                @click="updateEdit(scope.row, 0)"
                >编辑</el-button
              >
              <!-- <el-button
                type="text"
                size="small"
                @click="deleteAccount(scope.row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </template>
      </page>
      <route_config_inf_edit
        :show.sync="showDialog"
        :value="value"
        :action="action"
      ></route_config_inf_edit>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import RouteConfigInfEdit from './RouteConfigInfEdit.vue'

export default {
  name: 'route',
  components: {
    page: Page,
    route_config_inf_edit: RouteConfigInfEdit,
  },
  data() {
    return {
      timeDate: [],
      url: '/routeConfigInfo/selectList',
      action: '',
      form: {
        routeId: '',
        appId: '',
        productId: '',
        channelId: '',
        routeStatus: '',
        startDate: '',
        endDate: '',
      },
      showDialog: false,
      formLabelWidth: '100px',
      formData: null,
      value: {},
      agtList: [],
      channelList: [],
      productList: [],
      merchantList: [],
      channelInfoList: [],
    }
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate)
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
    },
    deleteAccount(row) {
      let routeId = row.routeId
      console.log(routeId)
      this.axios
        .get('/routeConfigInfo/routeChannelInfoDel', {
          params: {
            routeId: routeId,
          },
        })
        .then(res => {
          if (res.code === 200) {
            this.$bus.$emit('refresh') //通知刷新
            this.$notify({
              title: '提示',
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$notify.error({
              title: '提示',
              message: res.msg,
            })
          }
        })
    },
    updateEdit(row, num) {
      if (num === 1) {
        this.$bus.$emit('refreshButton', false) //查看
      }
      if (num === 0) {
        this.$bus.$emit('refreshButton', true) //编辑
        this.$bus.$emit('isDisabled', true)
      }
      this.action = 'edit'
      var newRowValue = Object.assign({}, row)
      newRowValue.fee = row.fee
      this.value = newRowValue
      this.showRoute = true
      this.showDialog = true
    },
    addRoute() {
      let row = {}
      row.num = '2'
      this.value = row
      this.action = 'add'
      this.$bus.$emit('isDisabled', false) //编辑
      this.$bus.$emit('refreshButton', true) //编辑
      this.showRoute = true
      this.showDialog = true
    },
  },
  mounted() {
    this.$bus.$on('setAgtList', agtList => {
      this.agtList = agtList
    }),
      this.$bus.$on('setChannelList', channelList => {
        this.channelList = channelList
      }),
      this.$bus.$on('setProductList', productList => {
        this.productList = productList
      })
  },
  created() {
    this.$axios
      .get('/merchant/selectListForOption', { params: {hasAgent:1} })
      .then(res => {
        this.merchantList = res.data
        // if (this.merchantList.length == 1) {
        //   this.form.appId = this.merchantList[0].value
        //   this.$bus.$emit('refresh')
        // }
      })

    this.$axios
      .get('/routeChannelInfo/selectListForOption', { params: {} })
      .then(res => {
        this.channelInfoList = res.data
      })
  },
}
</script>

<style scoped>
.container {
  margin: 15px;
  border: 1px solid #dce4ea;
  background: transparent;
  text-align: left;
  padding: 10px;
}
</style>